import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";

function formatPhoneNumber(value) {
  if (!value) return "";

  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}

let obj = {
  contactEmail: "",
  phone: "",
  tfaOn: false,
};

const TwoFactorPreReg = () => {
  const { userToken, SetSharedObject, sharedObject } = useUserStore(
    (state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
    })
  );
  const navigate = useNavigate();
  const [flag, setFlag] = useState(false);
  const [flagSuccess, setFlagSuccess] = useState(false);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [answers, setAnswers] = useState(obj);
  const [errEmail, SetErrEmail] = useState(false);

  const setAnswer = async (questionId, answer) => {
    setAnswers({ ...answers, [questionId]: answer });
  };

  useEffect(() => {
    SetErrCreateMsg(false);
    return () => {
      setAnswers(obj);
      setFlagSuccess(false);
    };
  }, []);

  const SubmitForm = async () => {
    setFlag(false);
    SetErrCreateMsg(false);
    SetErrMsg(false);
    setFlagSuccess(false);
    SetErrEmail(false);
    if (answers.contactEmail || answers.phone) {
      if (
        !isEmpty(answers.contactEmail) &&
        (containsSpacesOrSpecialChars(answers.contactEmail) ||
          answers.contactEmail.length < 4)
      ) {
        SetErrEmail(true);
        return;
      }

      let call = `/users/ValidateTFASettings?tfaPhone=${answers.phone ? answers.phone : ""
        }&tfaEmail=${answers.contactEmail ? answers.contactEmail : ""}&tfaOn=${answers.tfaOn
        }&userId=-1`;
      setProcessing(true);
      SetSharedObject("UserPreRegTwoFactor", answers);
      const res = await CallAPI(call, false, "get", userToken);
      SetSharedObject("ResponseCode", res.code);

      if (res.status === "SUCCESS") {
        setProcessing(false);
        setFlagSuccess(true);
        $("#TwoFactorPreRegSettingModal").modal("hide");
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrMsg(str);
        SetErrCreateMsg(true);
        setProcessing(false);
      }
    } else {
      setFlag(true);
      return;
    }
  };

  const changeTFA = () => {
    if (answers.tfaOn === true) {
      setAnswer("tfaOn", false);
    } else {
      setAnswer("tfaOn", true);
    }
  };

  const CloseModal = async () => {
    let obj = {
      contactEmail: "",
      phone: "",
      tfaOn: false,
    };
    setAnswers(obj);
    SetSharedObject("AddTfaFlag", true);
    setFlagSuccess(false);
    SetErrCreateMsg(false);
    $("#TwoFactorPreRegSettingModal").modal("hide");
  };

  const setPhone = async (val) => {
    if (val !== "") {
      setAnswer("phone", val);
    } else {
      setAnswer("phone", null);
    }
  };

  const setEmail = async (val) => {
    if (val !== "NotProvided") {
      setAnswer("contactEmail", val);
    } else {
      setAnswer("contactEmail", null);
    }
  };

  function formatContactEmail(val) {
    if (val === "NotProvided") {
      return "";
    } else {
      return val;
    }
  }

  const containsSpacesOrSpecialChars = (str) => {
    let flag = /[^a-zA-Z0-9-_@.]/.test(str);
    return flag;
  };

  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  
  return (
    <div className="TwoFactor">
      <div
        className="modal fade"
        id="TwoFactorPreRegSettingModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Two Factor Authentication Setting"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" id="myModalLabel">
                Two-Factor Authentication Setting
              </div>
              <button
                type="button"
                className="close"
                onClick={(e) => CloseModal()}
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {flagSuccess ? (
                <>
                  <div className="bi-success-check">
                    <i
                      className="bi bi-check2-circle"
                      alt="Success Checkmark"
                    ></i>
                  </div>
                  <div className="message-wrapper">
                    Two-Factor Authentication has been saved successfully.
                  </div>
                </>
              ) : (
                <>
                  <div className="descript-container">
                    Two-factor authentication is an enhanced security measure.
                    Once enabled, users will be prompted for additional
                    authentication code.
                  </div>
                  <div className="field-wrapper modal-content-form">
                    <label>Code Sent by Text Message</label>
                    <div>
                      <input
                        type="text"
                        name="Phone"
                        className="form-control"
                        onChange={(el) => setPhone(el.target.value)}
                        value={formatPhoneNumber(answers.phone)}
                      />
                    </div>
                  </div>
                  <div className="field-wrapper modal-content-form">
                    <label>Code Sent by Email</label>
                    <div>
                      <input
                        type="text"
                        name="ContactEmail"
                        className="form-control"
                        value={formatContactEmail(answers.contactEmail)}
                        onChange={(el) => setEmail(el.target.value)}
                      />
                    </div>
                    <div className="descript2-container line-s1 sp-margin3">
                      Email will be used if mobile number is not available.
                    </div>
                  </div>
                  {flag ? (
                    <div className="alert alert-danger field-wrapper modal-content-form">
                      Either Contact Email or Phone Number is required.
                    </div>
                  ) : null}
                  <div className="field-wrapper modal-content-form">
                    <label>
                      {/*{sharedObject?.TwoFactorObject?.twoFactorEnabled*/}
                      {/*  ? "Turn Off"*/}
                      {/*  : "Turn On"}*/}
                      Turn On:
                    </label>
                    {/*<input
                      type="checkbox"
                      name={"tfaOn"}
                      value={tfaOn}
                      checked={tfaOn}
                      className="form-control"
                      onClick={(el) => {
                        setTfaOn(el.target.checked);
                      }}
                    />*/}
                    {answers.tfaOn === true ? (
                      <>
                        <a
                          href="javascript:void(0);"
                          className="bi bi-shield-fill-check"
                          alt="Two-Factor Authentication Enabled Icon"
                          title="Two-Factor Authentication Enabled"
                          onClick={() => changeTFA()}
                        />
                      </>
                    ) : (
                      <>
                        <a
                          href="javascript:void(0);"
                          className="bi bi-shield-slash gray"
                          alt="Two-Factor Authentication Disabled Icon"
                          title="Two-Factor Authentication Disabled"
                          onClick={() => changeTFA()}
                        />
                      </>
                    )}
                  </div>
                </>
              )}
              {processing ? <div className="loading"></div> : null}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                />
              ) : null}
              {errEmail ? (
                <div className="alert alert-danger">
                  Please enter a valid email name with no spaces, commas, or
                  special characters.
                </div>
              ) : null}
            </div>
            <div className="modal-footer">
              {flagSuccess ? (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={(e) => CloseModal()}
                >
                  {" "}
                  Close{" "}
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => SubmitForm()}
                  >
                    {" "}
                    Save{" "}
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={(e) => CloseModal()}
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TwoFactorPreReg.defaultProps = {};

export default TwoFactorPreReg;
